import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Divider,
    Grid,
    Chip,
    Avatar,
    Tooltip,
    Toolbar,
    List,
    ListItem,
    ListItemText,
    Link
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

const InfoRow = ({ label, value, icon }) => (
    <Grid item xs={12} sm={6}>
        <Box display="flex" alignItems="center" gap={1} mb={1}>
            {icon && <Box color="text.secondary">{icon}</Box>}
            <Typography variant="body2" color="text.secondary">
                <strong>{label} :</strong> {value || '—'}
            </Typography>
        </Box>
    </Grid>
);

const ClientDetailsDrawer = ({ open, onClose, client , banques}) => {
    if (!client) return null;

    const isMorale = client.typePersonne === 'morale';

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: { xs: '100%', sm: 480 },
                    zIndex: (theme) => theme.zIndex.appBar - 1,
                },
            }}
        >
            <Toolbar />

            <Box p={3}>
                {/* Header */}
                <Box display="flex" alignItems="center" p={2} justifyContent="space-between" bgcolor="background.paper">
                    <Box display="flex" alignItems="center" gap={1}>
                        <Avatar sx={{ bgcolor: 'primary.main' }}>
                            {isMorale ? <BusinessIcon /> : <PersonIcon />}
                        </Avatar>
                        <Box>
                            <Typography variant="h6">Détails du client</Typography>
                            <Typography variant="caption" color="text.secondary">
                                Type : {client.typePersonne}
                            </Typography>
                        </Box>
                    </Box>
                    <Tooltip title="Fermer">
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Tooltip>
                </Box>

                <Divider />

                {/* Infos principales */}
                <Box p={3}>
                    <Typography variant="h5" gutterBottom>
                        {client.raisonSociale || `${client.prenom} ${client.nom}`}
                    </Typography>

                    <Box mb={2}>
                        <Chip
                            label={client.typePersonne}
                            color={isMorale ? 'info' : 'default'}
                            variant="outlined"
                            size="small"
                        />
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    {/* Infos détaillées */}
                    <InfoRow label="Email" value={client.email} icon={<EmailIcon fontSize="small" />} />

                        <InfoRow label="Téléphone" value={client.telephone} icon={<PhoneIcon fontSize="small" />} />
                        <InfoRow label="Email seconadaire" value={client.emailSecondaire} />
                        <InfoRow label="Adresse" value={client.adresse} />
                        <InfoRow label="Activité" value={client.activite} />
                        <InfoRow label="Code TVA" value={client.codeTva} />
                        <InfoRow label="Code Client" value={client.codeClient} />
                         <InfoRow label="Code" value={client.code} />
                        {!isMorale && (
                            <>
                                <InfoRow label="Nom" value={client.nom} />
                                <InfoRow label="Prénom" value={client.prenom} />
                                <InfoRow label="CIN" value={client.cin} />
                            </>
                        )}
                        <InfoRow label="ID RNE" value={client.idRne} />
                        <InfoRow label="Login TEJ" value={client.tejLogin} />

                    {/* Comptes bancaires */}
                    {client.comptesBancaires?.length > 0 && (
                        <>
                            <Divider sx={{ my: 3 }} />
                            <Typography variant="h6" gutterBottom>
                                Comptes bancaires
                            </Typography>
                            <List dense>
                                {client.comptesBancaires.map((compte, index) => {
                                    const banque = banques.find(b => b._id === compte.banque);

                                    return (
                                        <ListItem key={index} alignItems="flex-start">
                                            <ListItemText
                                                primary={
                                                    <Box display="flex" alignItems="center" gap={1}>
                                                        <AccountBalanceIcon fontSize="small" />
                                                        <strong>{banques.find(b => b._id === compte.banque)?.nom || 'Banque inconnue'}
                                                        </strong>
                                                        {banque?.urlLogin && (
                                                            <Link
                                                                href={banque.urlLogin}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                underline="hover"
                                                                sx={{ ml: 1 }}
                                                            >
                                                                (Se connecter)
                                                            </Link>
                                                        )}
                                                    </Box>
                                                }
                                                secondary={
                                                    <>
                                                        <Typography variant="body2">RIB : {compte.rib}</Typography>
                                                        <Typography variant="body2">Login : {compte.banqueLogin}</Typography>
                                                        <Typography variant="body2">Mot de passe : {compte.banquePassword}</Typography>
                                                    </>
                                                }
                                            />
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </>
                    )}
                </Box>
            </Box>
        </Drawer>
    );
};
export default ClientDetailsDrawer;
